module.exports = __webpack_public_path__ + "static/people_bg-d4f6498576a2e144f32e72e2f02baf2f.png";